import { render, staticRenderFns } from "./level.vue?vue&type=template&id=ec222298&scoped=true&"
import script from "./level.vue?vue&type=script&lang=ts&"
export * from "./level.vue?vue&type=script&lang=ts&"
import style0 from "./level.vue?vue&type=style&index=0&id=ec222298&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec222298",
  null
  
)

export default component.exports